import React from 'react';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const NotInGoodStandingIcon = ({ toolTipText = 'Not In Good Standing' }) => (
  <Icon tooltip={ toolTipText } iconObj={faTriangleExclamation} />
);

export default NotInGoodStandingIcon;